import { ApplicationConfig } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  provideRouter,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import { provideDataConnect } from '@sites/data-connect';
import { ENVIRONMENT } from '@sites/util-environment';
import { provideUtilErrors } from '@sites/util-errors';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    BrowserModule,
    provideRouter(
      appRoutes,
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      })
    ),
    provideUtilErrors(),
    provideDataConnect({
      baseUrl: environment.apiUrl,
    }),
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },
  ],
};
